import React, { useEffect, useRef } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import LabelCustomSmall from '../../../../label-custom-small'
import { useState } from 'react'
import {
  getEmpsJobsAPI,
  updateEmpsJobsAPI
} from '../../../../../services/employee'
import moment from 'moment'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useDebounce } from '@react-hook/debounce'
import Autocomplete from '../../../../custom/autocomplete'
import UseEmpsReportby from '../../../../../hooks/use-emps-reportby'
import UseEmpsTravels from '../../../../../hooks/use-emps-travels'
import UseEmpsTypes from '../../../../../hooks/use-emps-types'
import UsePayments from '../../../../../hooks/use-payments'
import UseEmpsProbations from '../../../../../hooks/use-emps-probations'
import UseEmpsStatus from '../../../../../hooks/use-emps-status'
import DatepickerCustom from '../../../../datepicker-custom'
import UseBanks from '../../../../../hooks/use-emps-banks'
import UseEmpsShifts from '../../../../../hooks/use-emps-shifts'
import Error_false from '../../../../error/error-false'
import ButtonSummit from '../_btn-summit'
import { useOutletContext } from 'react-router-dom'
import UseResignOption from '../../../../../hooks/use-resign-option'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../../../helper/check-user-admin'
import UsePhone from '../../../../../hooks/use-phone'
import SwalCustom from '../../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../../Constants'
import UseGroups from '../../../../../hooks/use-groups'
import UseTeams from '../../../../../hooks/use-teams'
import UsePositions from '../../../../../hooks/use-position'
import UseFactionAll from '../../../../../hooks/use-factions-all'
import UseDepartmentsAll from '../../../../../hooks/use-departmentsAll'
import useNumberInput from '../../../../../helper/input-fix-num'
import useEngNumInput from '../../../../../helper/input-fix-en-num'
import UseEmpsSupervisor from '../../../../../hooks/use-emps-supervisor'
import UseSecretary from '../../../../../hooks/use-secretary'
import IncomeCard from './IncomeCard'
import AccountCard from './AccountCard'
import { fnDateEn } from '../../../../../helper/fnDateEn'
import CostCard from './CostCard'
import UseEmpsLocation from '../../../../../hooks/use-emps-airport'
import UseEmpsProject from '../../../../../hooks/use-emps-project'
import UseOrgLevelId from '../../../../../hooks/useOrgLevelId'
import SwalLarkSyncWarning, {
  isLarkSyncWarning
} from '../../../../../alert/swal-lark-sync'
import { useTranslation } from 'react-i18next'

function JopPosition() {
  const { t } = useTranslation()
  const [isResign, setIsResign] = useState(false)
  const [isPassProbation, setIsPassProbation] = useState(false)
  const { dataUser } = useOutletContext()
  const roleId = useSelector((state) => state.roleReducer.role)
  const orgLevelIdOption = UseOrgLevelId()

  const orgId = dataUser?.orgId
  const code = dataUser?.code
  const [schemaCustom, setSchemaCustom] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const schema = {
      code: yup.string().required('กรุณาระบุรหัสพนักงาน'),
      empProbations: yup.object().required('กรุณาระบุสถานะทดลองงาน'),
      empsTypes: yup.object().required('กรุณาระบุประเภทพนักงาน'),
      startDate: yup.string().required('กรุณาระบุวันที่เริ่มงาน'),

      reportby: yup.object().required('กรุณาระบุผู้บังคับบัญชา'),
      payment: yup.object().required('กรุณาระบุประเภทการจ่ายเงิน'),
      bank: yup.object().required('กรุณาระบุบัญชีธนาคาร'),
      codeBank: yup.string().required('กรุณาระบุเลขบัญชี'),
      shift: yup.object().required('กรุณาระบุตารางกะ'),
      travel: yup.object().required('กรุณาระบุการเดินทาง'),
      fingerID: yup.string().required('กรุณาระบุข้อมูล'),
      divisions: yup.object().required('กรุณาระบุสายงาน'),
      department: yup.object().required('กรุณาระบุแผนก'),
      faction: yup.object().required('กรุณาระบุฝ่าย'),
      team: yup.object().required('กรุณาระบุทีม'),
      position: yup.object().required('กรุณาระบุตำแหน่ง'),
      level_id: yup.string().required('กรุณาระบุเลเวล'),
      paymentGroup: yup.object().required('กรุณาระบุกลุ่มรายได้'),
      ...(isPassProbation && {
        employDate: yup.string().required('กรุณาระบุวันที่บรรจุงาน')
      }),
      ...(isResign && {
        resigns: yup.object().required('กรุณาระบุสาเหตุการลาออก'),
        endDate: yup.string().required('กรุณาระบุวันพ้นสภาพ'),
        lastDate: yup.string().required('กรุณาระบุวันทำงานวันสุดท้าย')
      })
    }
    setSchemaCustom(schema)
  }, [isResign, isPassProbation])

  const schema = yup.object(schemaCustom).required()

  const {
    control,
    setValue,
    reset,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true // ตัวนี้จะทำให้กระโดดไปหา Input ที่ error ตัวแรกทันที
  })

  const optionSecretary = UseSecretary(dataUser?.orgId)

  const param = { orgId, code }

  const [dataDetail, setDataDetail] = useState()
  const [keyReportTo, setKeyReportTo] = useDebounce('', 1000)
  const [keySupervisor, setKeySupervisor] = useDebounce('', 1000)

  const reportby = UseEmpsReportby(orgId, keyReportTo)
  const supervisor = UseEmpsSupervisor(orgId, keySupervisor)

  const empsTypes = UseEmpsTypes()
  const phone = UsePhone()
  const payments = UsePayments()
  const airports = UseEmpsLocation()
  const projects = UseEmpsProject(orgId)

  const travels = UseEmpsTravels()

  const empStatus = UseEmpsStatus()

  const banks = UseBanks()
  const shifts = UseEmpsShifts()
  const empProbations = UseEmpsProbations()
  const [isRead, setIsRead] = useState(true)
  const resignsOption = UseResignOption()

  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)

  const divisions = UseGroups(orgId) //สายงาน
  const factions = UseFactionAll(orgId, divisionId)
  const department = UseDepartmentsAll(orgId, divisionId, factionId) //แผนก
  const teams = UseTeams(orgId, divisionId, departmentId) //ทีม
  const positions = UsePositions(orgId, divisionId, departmentId, teamId) //ตำแน่ง
  const [endDate, setEndDate] = useState()

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const handleKeyDownENnum = useEngNumInput(inputRef)

  useEffect(() => {
    if (dataUser) {
      getEmpsJobs()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser])

  const getEmpsJobs = async () => {
    setIsLoading(true)
    const body = { orgId: dataUser.orgId, code: dataUser.code }
    setIsLoading(false)
    const result = await getEmpsJobsAPI(body)
    if (!result) return
    if (result.status) {
      setDataDetail(result.result[0])
      fnSetDataDetail(result.result[0])
    } else {
      setDataDetail()
    }
  }

  const [keyUsername, setKeyUsername] = useDebounce('', 1000)
  const [isUsername, setIsUsername] = useState(true)
  const [isSave, setIsSave] = useState(false)

  const fnSetDataDetail = (d) => {
    if (d) {
      setValue('reportby', {
        value: d.report_to,
        label: d.report_to
      })

      d.report_to_ipop &&
        setValue('reportby_ipop', {
          value: d.report_to_ipop,
          label: d.report_to_ipop
        })

      setValue('supervisor', {
        value: d.supervisor,
        label: d.supervisor_username
      })

      d.newReportTo &&
        setValue('newReportTo', {
          value: d.newReportTo,
          label: d.newReportTo
        })

      setValue('assetsId', d.asset_id)

      d.probation_id &&
        setValue('empProbations', {
          value: d.probation_id,
          label: d.probation
        })

      setIsPassProbation(d.probation_id === 3)

      setValue('empsTypes', {
        value: d.type_id,
        label: d.type
      })

      setValue('empStatus', {
        value: d.status_id,
        label: d.status
      })
      setValue('divisions', {
        label: d.division_en,
        value: d.division_id
      })
      setDivisionId(d.ds_id)

      setFactionId(d.fac_id)

      setValue('faction', {
        label: d.faction_en,
        value: d.fac_id
      })

      setValue('department', {
        value: d.dm_id,
        label: d.department_en
      })

      setValue('team', {
        value: d.team_id,
        label: d.team_en
      })

      setDepartmentId(d.dm_id)
      setTeamId(d.team_id)

      setValue('position', {
        label: d?.position_en,
        value: d.position_id
      })
      setValue(
        'lastDate',
        d.last_date !== '0000-00-00' && d.last_date
          ? moment(d.last_date).format('YYYY-MM-DD')
          : ''
      )
      d.last_date !== '0000-00-00' && d.last_date && setError('lastDate', false)

      d?.resign_id &&
        setValue('resigns', {
          value: d?.resign_id,
          label: d?.resign
        })

      setValue(
        'endDate',
        d.end_date !== '0000-00-00' && d.end_date
          ? moment(d.end_date).format('YYYY-MM-DD')
          : ''
      )
      setEndDate(
        d.end_date !== '0000-00-00' && d.end_date
          ? moment(d.end_date).format('YYYY-MM-DD')
          : ''
      )

      setValue('empProbations', {
        value: d.probation_id,
        label: d.probation
      })

      setValue('shift', {
        value: d.shift_id,
        label: `${d?.shift ?? '-'} `
      })

      setValue(
        'startDate',
        d.start_date !== '0000-00-00' && d.start_date
          ? moment(d.start_date).format('YYYY-MM-DD')
          : ''
      )

      setValue(
        'contractStartDate',
        d.contract_start_date !== '0000-00-00' && d.contract_start_date
          ? moment(d.contract_start_date).format('YYYY-MM-DD')
          : ''
      )

      setValue(
        'employDate',
        d.employed_date !== '0000-00-00' && d.employed_date
          ? moment(d.employed_date).format('YYYY-MM-DD')
          : ''
      )

      setValue(
        'contractDate',
        d.contract_end !== '0000-00-00' && d.contract_end
          ? moment(d.contract_end).format('YYYY-MM-DD')
          : ''
      )

      setValue('travel', {
        value: d.travelling_id,
        label: d.travelling
      })
      setError('travel', false)

      setValue('payment', {
        value: d.payment_id,
        label: d.payment
      })
      setValue('bank', {
        value: d.bank,
        label: d.bank
      })
      setError('bank', false)

      setValue('codeBank', d.account_no)

      setValue('code', d.code)

      setValue('username', d.username)

      setValue('level_id', d.level_id)

      setValue('fingerID', d.finger_id)

      setValue('email', d.email)

      setValue('intra_tel', d.intra_tel)

      setValue('certificate', d.certificate_detail)

      setValue('phone', {
        label: d.phone_packet,
        value: d.phone_packet_id
      })

      const secretary = optionSecretary.find(
        (item) => item.label === d?.secretary_username
      )
      secretary && setValue('secretary', secretary)

      d.ot_flat_rate_id &&
        setValue('otFlatRate', {
          label: d.ot_flat_rate,
          value: d.ot_flat_rate_id
        })

        setValue('otShift', {
          label: d.ot_shift ? 'มี' : 'ไม่มี',
          value: d.ot_shift ? 1 : 0
        })

      d.lang_fee_id &&
        setValue('languageFee', {
          label: d.lang_fee,
          value: d.lang_fee_id
        })

      d.exp_fee_id &&
        setValue('experienceFee', {
          label: d.exp_fee,
          value: d.exp_fee_id
        })

      d.shift_flat_rate_id &&
        setValue('shiftFlatRate', {
          label: d.shift_flat_rate,
          value: d.shift_flat_rate_id
        })

      d.payment_group_id &&
        setValue('paymentGroup', {
          label: d.payment_group,
          value: d.payment_group_id
        })

      d.location_id &&
        setValue('location', {
          label: d.location_code,
          value: d.location_id
        })

      d.project_id &&
        setValue('project', {
          label: d.project_name_en,
          value: d.project_id
        })

      d.org_level_id &&
        setValue('orgLevelId', {
          label: `${d.org_level_code + ' - ' + d.org_level_en}`,
          value: d.org_level_id
        })
    }
  }

  const onSubmit = (data) => {
    const d = data
    const body = {
      fingerId: d.fingerID ?? '',
      username: d.username ?? '',
      email: d.email ?? '',
      intraTel: d.intra_tel ?? '',
      certificateDetail: d?.certificate ?? '',
      typeId: d.empsTypes?.value ?? '',
      probationId: d.empProbations?.value ?? '',
      reportTo: d.reportby?.value ?? '',

      reportToIpop: d.reportby_ipop?.value ?? '',

      supervisor: d.supervisor?.value ?? '',
      shiftId: d.shift?.value ?? '',
      travellingId: d.travel?.value ?? '',
      paymentId: d.payment?.value ?? '',
      bank: d.bank?.label ?? '',
      accountNo: d.codeBank ?? '',
      startDate: d.startDate ?? '',
      employDate: d.employDate ?? '',
      contractDate: d.contractDate ?? '',
      assetId: d.assetsId ?? '',
      statusId: d.empStatus?.value,
      endDate: d.endDate ?? '',
      resign: d.resigns?.label ?? '',
      phonePacketId: d.phone?.value,
      lastDate: d.lastDate,
      newReportTo: d.newReportTo?.value ?? '',
      levelId: d.level_id ?? '',
      division: d.divisions?.data ?? dataDetail.division ?? '',
      divisionId: d.divisions?.value ?? divisionId,
      factionId: d.faction.value ?? factionId,
      faction: d.faction.data ?? dataDetail.faction ?? '', //เพิ่ม ฝ่าย
      departmentId: d.department?.value,
      department: d.department?.data ?? dataDetail.department ?? '',
      positionId: d.position.value,
      positionEn: d.position?.label ?? dataDetail.position ?? '',
      teamEn: d.team?.label ?? dataDetail.team_en ?? '',
      teamId: d.team.value ?? teamId,
      secretary: d.secretary?.value ?? '',

      otFlatRateId: d.otFlatRate?.value ?? '',
      otShift: d.otShift?.value ?? 0,
      langFeeId: d.languageFee?.value ?? '',
      expFeeId: d.experienceFee?.value ?? '',
      shiftFlatRateId: d.shiftFlatRate?.value ?? '',

      contractStartDate: d.contractStartDate,
      paymentGroupId: d.paymentGroup?.value,

      projectId: d.project?.value,
      locationId: d.location?.value,
      orgLevelId: d.orgLevelId?.value ?? ''
    }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateEmps(body)
      }
    })
  }

  const updateEmps = async (data) => {
    const result = await updateEmpsJobsAPI(param, data)
    setIsSave(false)
    if (!result) return
    if (isLarkSyncWarning(result.msg)) {
      SwalLarkSyncWarning(t, result.msg)
      setIsRead(!isRead)
      getEmpsJobs()
      return
    }
    if (result.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      })
      setIsRead(!isRead)
      getEmpsJobs()
    } else {
      Error_false(result)
    }
  }
  const fnCancle = () => {
    fnSetDataDetail(dataDetail)
  }

  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)
  const SkeletonBody = <span className="placeholder col-12"></span>

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row style={{ rowGap: '15px' }}>
        <Col xl={12} className="d-flex justify-content-between">
          <span className="my-auto text-primary">Job Position</span>
          {roles?.status_id === 1 && (
            <ButtonSummit
              fnCancle={fnCancle}
              isRead={isRead}
              setIsRead={setIsRead}
              isSave={isSave}
              handleSubmit={handleSubmit(onSubmit)}
            />
          )}
        </Col>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            รหัสพนักงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'code'}
              control={control}
              render={({
                field: { value = dataDetail?.code ?? '', onChange }
              }) => (
                <Form.Control
                  disabled
                  minLength={7}
                  maxLength={10}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.code ?? ''}
                  <span className="text-secondary small">
                    ({dataDetail?.recruitment_no ?? ' ไม่พบใบสมัครงาน '})
                  </span>
                </div>
              )}
            </>
          )}
          {errors.code?.message && (
            <label className="small text-danger">{errors.code.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Person ID
          </LabelCustomSmall>
          {!isRead ? (
            <Form.Control disabled value={dataDetail?.person_id} />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.person_id ?? ''}
                </div>
              )}
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Finger ID
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'fingerID'}
              control={control}
              render={({
                field: { onChange, value = dataDetail?.finger_id ?? '' }
              }) => (
                <Form.Control
                  disabled={isRead}
                  type="text"
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.finger_id ?? ''}
                </div>
              )}
            </>
          )}

          {errors.fingerID?.message && (
            <label className="small text-danger">
              {errors.fingerID.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Username{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'username'}
              control={control}
              render={({ field: { value = dataDetail?.username ?? '' } }) => (
                <Form.Control
                  value={value}
                  disabled={isRead}
                  onKeyDown={handleKeyDownENnum}
                  className={`${
                    !isUsername && keyUsername
                      ? 'text-danger border-danger'
                      : ''
                  }`}
                  onChange={(d) => {
                    setValue('username', d.target.value)
                    setKeyUsername(d.target.value)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.username ?? '-'}
                </div>
              )}
            </>
          )}

          {!isUsername && keyUsername && (
            <label className="small text-danger">
              ชื่อผู้ใช้นี้มีในระบบแล้ว
            </label>
          )}
          {errors.username?.message && (
            <label className="small text-danger">
              {errors.username.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Email (Office){' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'email'}
              control={control}
              render={({
                field: { onChange, value = dataDetail?.email ?? '' }
              }) => (
                <Form.Control
                  disabled={isRead}
                  type="email"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">{dataDetail?.email ?? '-'}</div>
              )}
            </>
          )}
          {errors.email?.message && (
            <label className="small text-danger">{errors.email.message}</label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            สายงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'divisions'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  disabled={isRead}
                  value={value}
                  options={divisions}
                  onChange={(res) => {
                    setError('divisions', res)
                    setValue('divisions', res ?? dataDetail.ds_id)
                    setValue('department', {})
                    setValue('team', {})
                    setValue('position', {})
                    setValue('level_id', '')
                    setValue('faction', {})

                    setDivisionId(res.value)
                    setFactionId(0)
                    setDepartmentId(0)
                    setTeamId(0)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {dataDetail?.division_en ?? ''}
                    {' ('}
                    {dataDetail?.division || ''}
                    {')'}
                  </div>
                  <div className="fw-light small">
                    {dataDetail?.division_th ?? ''}
                  </div>
                </>
              )}
            </>
          )}
          {errors.divisions?.message && (
            <label className="small text-danger">
              {errors.divisions.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ฝ่าย
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'faction'}
              control={control}
              render={({ field: { value = {}, onChange } }) => (
                <Autocomplete
                  disabled={divisionId > 0 && !isRead ? false : true}
                  value={value}
                  options={factions}
                  onChange={(res) => {
                    setError('faction', res)
                    setValue('faction', res)

                    setValue('department', {})
                    setValue('team', {})
                    setValue('position', {})
                    setValue('level_id', '')

                    setFactionId(res.value)
                    setDepartmentId(0)
                    setTeamId(0)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {dataDetail?.faction_en ?? '-'}
                    {' ('}
                    {dataDetail?.faction || ''}
                    {')'}
                  </div>
                  <div className="fw-light small">
                    {dataDetail?.faction_th ?? '-'}
                  </div>
                </>
              )}
            </>
          )}
          {errors.faction?.message && (
            <label className="small text-danger">
              {errors.faction.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            แผนก
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'department'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={factionId > 0 && !isRead ? false : true}
                  options={department}
                  onChange={(res) => {
                    setDepartmentId(res.value)
                    setError('department', res)

                    setValue('department', res)
                    setValue('team', {})
                    setValue('position', {})
                    setValue('level_id', '')
                    setTeamId(0)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {dataDetail?.department_en ?? '-'} {' ('}
                    {dataDetail?.department || ''}
                    {')'}
                  </div>
                  <div className="fw-light small">
                    {dataDetail?.department_th ?? '-'}
                  </div>
                </>
              )}
            </>
          )}
          {errors.department?.message && (
            <label className="small text-danger">
              {errors.department.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ทีม
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'team'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={departmentId > 0 && !isRead ? false : true}
                  options={teams}
                  onChange={(res) => {
                    setTeamId(res.value)
                    setValue('team', res)
                    setError('team', res)

                    setValue('position', {})
                    setValue('level_id', '')
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {dataDetail?.team_en ?? '-'}
                  </div>
                  <div className="fw-light small">
                    {dataDetail?.team_th ?? '-'}
                  </div>
                </>
              )}
            </>
          )}
          {errors.team?.message && (
            <label className="small text-danger">{errors.team.message}</label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ตำแหน่ง
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'position'}
              control={control}
              render={({ field: { value = {} } }) => (
                <Autocomplete
                  value={value}
                  disabled={teamId > 0 && !isRead ? false : true}
                  options={positions}
                  onChange={(res) => {
                    setValue('position', res)
                    setError('position', res)
                    setValue('level_id', res.level_id)
                    setError('level_id', res.level_id)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {dataDetail?.position_en ?? '-'}
                  </div>
                  <div className="fw-light small">
                    {dataDetail?.position_th ?? '-'}
                  </div>
                </>
              )}
            </>
          )}
          {errors.position?.message && (
            <label className="small text-danger">
              {errors.position.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Level
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'level_id'}
              control={control}
              render={({
                field: { onChange, value = dataDetail?.level_id ?? '' }
              }) => (
                <Form.Control
                  disabled={true}
                  readOnly
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.level_id ?? '-'}
                </div>
              )}
            </>
          )}
          {errors.level_id?.message && (
            <label className="small text-danger">
              {errors.level_id.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Lark Level ID{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'orgLevelId'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  isClearable={true}
                  options={orgLevelIdOption}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {`${dataDetail?.org_level_code ?? ''} - ${
                      dataDetail?.org_level_en ?? ''
                    }`}
                  </div>
                </>
              )}
            </>
          )}
          {errors.reportby?.message && (
            <label className="small text-danger">
              {errors.reportby.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ผู้บังคับบัญชา
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'reportby'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={reportby}
                  value={value}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setKeyReportTo(data)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {/* {dataDetail?.report_to ?? '-'} */}
                    {`${dataDetail?.report_to_name_en ?? ''} ${
                      dataDetail?.report_to_surname_en ?? ''
                    } (${dataDetail?.report_to ?? '-'})`}
                  </div>
                  <div className="fw-light small">
                    {`${dataDetail?.report_to_name_th ?? ''} ${
                      dataDetail?.report_to_surname_th ?? ''
                    }`}
                  </div>
                </>
              )}
            </>
          )}
          {errors.reportby?.message && (
            <label className="small text-danger">
              {errors.reportby.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ผู้บังคับบัญชา (IPOP)
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'reportby_ipop'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={reportby}
                  value={value}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setKeyReportTo(data)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {/* {dataDetail?.report_to ?? '-'} */}
                    {`${dataDetail?.report_to_ipop_name_en ?? ''} ${
                      dataDetail?.report_to_ipop_surname_en ?? ''
                    } (${dataDetail?.report_to_ipop ?? '-'})`}
                  </div>
                  <div className="fw-light small">
                    {`${dataDetail?.report_to_ipop_name_th ?? ''} ${
                      dataDetail?.report_to_ipop_surname_th ?? ''
                    }`}
                  </div>
                </>
              )}
            </>
          )}
          {errors.reportby_ipop?.message && (
            <label className="small text-danger">
              {errors.reportby_ipop.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Supervisor
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'supervisor'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={supervisor}
                  value={value}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setKeySupervisor(data)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {`${dataDetail?.supervisor_name_en ?? ''} ${
                      dataDetail?.supervisor_surname_en ?? ''
                    } (${dataDetail?.supervisor_username ?? '-'})`}
                  </div>
                  <div className="fw-light small">
                    {`${dataDetail?.supervisor_name_th ?? ''} ${
                      dataDetail?.supervisor_surname_th ?? ''
                    }`}
                  </div>
                </>
              )}
            </>
          )}
          {errors.supervisor?.message && (
            <label className="small text-danger">
              {errors.supervisor.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Secretary{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'secretary'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={optionSecretary}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <>
                  <div className="fw-light small">
                    {`${dataDetail?.secretary_name_en ?? ''} ${
                      dataDetail?.secretary_surname_en ?? ''
                    } ${
                      dataDetail?.secretary_username
                        ? `(${dataDetail?.secretary_username ?? '-'})`
                        : '-'
                    }`}
                  </div>
                  <div className="fw-light small">
                    {`${dataDetail?.secretary_name_th ?? ''} ${
                      dataDetail?.secretary_surname_th ?? ''
                    }`}
                  </div>
                </>
              )}
            </>
          )}
          {errors.secretary?.message && (
            <label className="small text-danger">
              {errors.secretary.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            เบอร์ภายใน{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'intra_tel'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  maxLength={5}
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.intra_tel ?? '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>
        {/* certificate */}
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Certificate{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'certificate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  disabled={isRead}
                  maxLength={100}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.certificate_detail ?? '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Project{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'project'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  isClearable={true}
                  options={projects}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.project_name_en ?? '-'}
            </div>
          )}
          {errors.project?.message && (
            <label className="small text-danger">
              {errors.project.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Location
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'location'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  isClearable={false}
                  options={airports}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <div className="fw-light small">
              {dataDetail?.location_code ?? '-'}
            </div>
          )}
          {errors.location?.message && (
            <label className="small text-danger">
              {errors.location.message}
            </label>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            สถานะพนักงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'empStatus'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={empStatus}
                  value={value}
                  onChange={(d) => {
                    setIsResign(!d.value)
                    onChange(d)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">{dataDetail?.status ?? ''}</div>
              )}
            </>
          )}
          {errors.empStatus?.message && (
            <label className="small text-danger">
              {errors.empStatus.message}
            </label>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            ประเภทพนักงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'empsTypes'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={empsTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">{dataDetail?.type ?? ''}</div>
              )}
            </>
          )}
          {errors.empsTypes?.message && (
            <label className="small text-danger">
              {errors.empsTypes.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            กะทำงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'shift'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={shifts}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {`${dataDetail?.shift || '-'}`}
                </div>
              )}
            </>
          )}
          {errors.shift?.message && (
            <label className="small text-danger">{errors.shift.message}</label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            สถานะทดลองงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'empProbations'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  disabled={isRead}
                  options={empProbations}
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                    setIsPassProbation(e.value === 3)
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.probation ?? ''}
                </div>
              )}
            </>
          )}
          {errors.empProbations?.message && (
            <label className="small text-danger">
              {errors.empProbations.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันที่เริ่มงาน
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'startDate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <DatepickerCustom
                  isClearable={false}
                  disabled={isRead}
                  value={value}
                  onChange={([date]) => {
                    if (date) {
                      onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                    }
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {moment(dataDetail?.start_date).format('DD/MM/YYYY') ?? ''}
                </div>
              )}
            </>
          )}
          {errors.startDate?.message && (
            <label className="small text-danger">
              {errors.startDate.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันที่บรรจุ{' '}
            {!isPassProbation && !isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'employDate'}
              control={control}
              render={({ field: { onChange, value = '', ref } }) => (
                <DatepickerCustom
                  disabled={isRead}
                  value={value}
                  onChange={([date]) => {
                    onChange(`${date ? moment(date).format('YYYY-MM-DD') : ''}`)
                  }}
                  // ref={ref}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail && dataDetail.employed_date
                    ? moment(
                        dataDetail.employed_date,
                        'YYYY-MM-DD',
                        true
                      ).isValid()
                      ? moment(dataDetail.employed_date).format('DD/MM/YYYY')
                      : '-'
                    : '-'}
                </div>
              )}
            </>
          )}
          {errors.employDate?.message && (
            <label className="small text-danger">
              {errors.employDate.message}
            </label>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันที่เริ่มสัญญา{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'contractStartDate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <DatepickerCustom
                  disabled={isRead}
                  value={value}
                  onChange={([date]) => {
                    onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail && dataDetail.contract_start_date
                    ? moment(dataDetail.contract_start_date).format(
                        'DD/MM/YYYY'
                      )
                    : '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันที่สิ้นสุดสัญญา{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'contractDate'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <DatepickerCustom
                  disabled={isRead}
                  value={value}
                  onChange={([date]) => {
                    onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                  }}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail && dataDetail.contract_end
                    ? moment(
                        dataDetail.contract_end,
                        'YYYY-MM-DD',
                        true
                      ).isValid()
                      ? moment(dataDetail.contract_end).format('DD/MM/YYYY')
                      : '-'
                    : '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันทำงานวันสุดท้าย{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <>
              <Controller
                name={'lastDate'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <DatepickerCustom
                    disabled={true}
                    isClearable={false}
                    value={value}
                    onChange={([date]) => {
                      onChange(date ? fnDateEn(date).format('YYYY-MM-DD') : '')
                    }}
                  />
                )}
              />
              {errors.lastDate?.message && (
                <label className="small text-danger">
                  {errors.lastDate?.message}
                </label>
              )}
            </>
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail && dataDetail.last_date
                    ? moment(dataDetail.last_date, 'YYYY-MM-DD', true).isValid()
                      ? moment(dataDetail.last_date).format('DD/MM/YYYY')
                      : '-'
                    : '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>
        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            วันที่พ้นสภาพ{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <>
              <Controller
                name="endDate"
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <DatepickerCustom
                    disabled={isRead}
                    value={value}
                    onChange={([date]) => {
                      // setValue(
                      //   'endDate',
                      //   date ? moment(date).format('YYYY-MM-DD') : ''
                      // )
                      setValue(
                        'lastDate',
                        date
                          ? moment(date)
                              .subtract(1, 'days')
                              .format('YYYY-MM-DD')
                          : ''
                      )
                      onChange(date ? fnDateEn(date).format('YYYY-MM-DD') : '')
                      setEndDate(date ? moment(date).format('YYYY-MM-DD') : '')
                    }}
                  />
                )}
              />
              {errors.endDate?.message && (
                <label className="small text-danger">กรุณาระบุวันพ้นสภาพ</label>
              )}
            </>
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.end_date && dataDetail?.end_date !== '0000-00-00'
                    ? (moment(dataDetail?.end_date).format('DD/MM/YYYY') ?? '')
                    : '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            สาเหตุการลาออก{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <>
              <Controller
                name={'resigns'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    isClearable={true}
                    disabled={isRead}
                    options={resignsOption}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.resigns?.message && (
                <label className="small text-danger">
                  กรุณาระบุสาเหตุการลาออก
                </label>
              )}
            </>
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.resign ?? '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>

        <>
          {dataDetail && dataDetail.is_head && (
            <ColFrom>
              <LabelCustomSmall
                className={`${!isRead ? 'fw-light' : 'fw-bold'}`}
              >
                ผู้รับผิดชอบแทน
              </LabelCustomSmall>
              {!isRead ? (
                <Controller
                  name={'newReportTo'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Autocomplete
                      isClearable={true}
                      disabled={isRead}
                      options={reportby}
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              ) : (
                <>
                  {isLoading ? (
                    SkeletonBody
                  ) : (
                    <div className="fw-light small">
                      {dataDetail?.new_report_to ?? '-'}
                    </div>
                  )}
                </>
              )}
            </ColFrom>
          )}
        </>
        {/* )} */}

        <ColFrom>
          <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
            Assets ID{' '}
            {!isRead && (
              <span className=" " style={{ color: '#fec203' }}>
                (ถ้ามี)
              </span>
            )}
          </LabelCustomSmall>
          {!isRead ? (
            <Controller
              name={'assetsId'}
              control={control}
              render={({ field: { value = ``, onChange } }) => (
                <Form.Control
                  disabled={isRead}
                  type="number"
                  value={value}
                  onChange={onChange}
                  onKeyDown={handleKeyDownNum}
                />
              )}
            />
          ) : (
            <>
              {isLoading ? (
                SkeletonBody
              ) : (
                <div className="fw-light small">
                  {dataDetail?.asset_id ?? '-'}
                </div>
              )}
            </>
          )}
        </ColFrom>

        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <IncomeCard
          isRead={isRead}
          dataDetail={dataDetail}
          travels={travels}
          control={control}
          errors={errors}
          phone={phone}
        />
        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <CostCard isRead={isRead} dataDetail={dataDetail} />
        <Col xl={12}>
          <div className="border-bottom mt-3 mb-3"> </div>
        </Col>
        <AccountCard
          isRead={isRead}
          control={control}
          errors={errors}
          payments={payments}
          dataDetail={dataDetail}
          banks={banks}
        />
      </Row>
    </Form>
  )
}

const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}

export default JopPosition
